(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CompanyStatusFranchiserFormController', CompanyStatusFranchiserFormController)

    /** @ngInject */
    function CompanyStatusFranchiserFormController($state, $stateParams, LoadingHelper, UtilHelper, sweetAlert, CompanyStatusService) {
        const vm = this;
        const companyStatusId = $stateParams.companyStatusId;

        vm.saveCompanyStatus = () => {
            LoadingHelper.startLoading('.loading-holder');

            if (!vm.companyStatusData.Id) {
                CompanyStatusService
                    .post(vm.companyStatusData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let companyStatusData = {
                    Id: companyStatusId,
                    ExternalCode: vm.companyStatusData.ExternalCode,
                    Description: vm.companyStatusData.Description
                };

                CompanyStatusService
                    .put(companyStatusData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteCompanyStatus = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    CompanyStatusService
                        .deleteData(companyStatusId)
                        .then(() => {
                            $state.go('app.franchiser-company-status-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getCompanyStatus() {
            if (!companyStatusId)
                return;

            LoadingHelper.startLoading('.loading-holder');

            CompanyStatusService
                .get(companyStatusId)
                .then(success => {
                    vm.companyStatusData = success;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                vm.companyStatusData = success;

                $state.go('app.franchiser-company-status-edit', {
                    companyStatusId: vm.companyStatusData.Id
                }, {
                    notify: false
                });

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function init() {
            vm.companyStatusData = {};

            getCompanyStatus();
        }
    }
}());